<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid, reset, errors}" ref="observer">
    <artisio-modal :visible="modal.show" :data="model" :title="$t(`Add New Template`)" @show="onShow" size="lg"
                   @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)" :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')" :is-loading="loading" scrollable>
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <template-type-select-input-widget :model="model" attribute="key" @select="onTemplateTypeChange"
                                             @unselect="onTemplateUnselect"/>
        </div>
        <div class="col-md-12" v-if="model.template_type">
          <p>{{ model.template_type.description }}</p>
        </div>
      </div>
      <b-tabs v-model="currentTab" class="custom-tabs" content-class="bg-white p-2">
        <email-form :model="model"/>
        <sms-form :model="model"/>
      </b-tabs>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import ArtisioModal from "../../../core/components/artisio-modal/ArtisioModal";
  import InputWidget from "../../../core/components/input-widget/InputWidget";
  import TemplateModel from "./Template.model";
  import {createNamespacedHelpers} from "vuex";
  import EmailForm from "@/modules/setup/templates/EmailForm";
  import SmsForm from "@/modules/setup/templates/SmsForm";
  import TemplateTypeSelectInputWidget from "@/core/widgets/TemplateTypeSelectInputWidget";

  const {mapState, mapActions} = createNamespacedHelpers('setup/templates');
  const {mapState: mapStateGlobal} = createNamespacedHelpers('global');

  export default {
    name: "TemplateModal",
    components: {TemplateTypeSelectInputWidget, SmsForm, EmailForm, InputWidget, ArtisioModal},
    data() {
      return {
        currentTab: 0,
        loading: false,
        showConfirmation: true,
        model: new TemplateModel(),
      }
    },
    computed: {
      ...mapState(['modal']),
    },
    methods: {
      ...mapActions(['hideModal', 'createTemplate']),
      onShow() {
        this.showConfirmation = true
      },
      onHidden() {
        this.model = new TemplateModel();
        this.hideModal();
      },
      onTemplateTypeChange(data) {
        this.model.template_type = data
      },
      onTemplateUnselect() {
        this.model.template_type = null
      },
      async onSubmit() {
        this.model.resetErrors();

        this.loading = true;
        let response = await this.createTemplate(this.model);
        this.loading = false;

        if (response.success) {
          this.$toast('success', this.$t('Template was successfully created'));
          this.showConfirmation = false;
          this.hideModal();
        } else {
          this.showConfirmation = true;
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0]);
          } else if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
